import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ebbb0cb")

_pushScopeId("data-v-2ebbb0cb")
const _hoisted_1 = { class: "regions" }
const _hoisted_2 = {
  key: 0,
  class: "regions__list list"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: ["regions__button button", { active: $setup.activeButtonRegion }],
      onClick: _cache[1] || (_cache[1] = (...args) => ($setup.toggleActiveButton(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.region')) + " ", 1 /* TEXT */),
      _createVNode(_component_svg_icon, { name: "arrowdown2" })
    ], 2),
    ($setup.activeButtonRegion)
      ? (_openBlock(), _createBlock("ul", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.CITIES, (city) => {
            return (_openBlock(), _createBlock("li", {
              key: city.name,
              class: "list__item"
            }, [
              _createVNode("a", {
                class: "link",
                "active-class": "active",
                href: city.href,
                exact: ""
              }, _toDisplayString(_ctx.$t('app.' + city.name)), 9, ["href"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside_element, () => ($setup.activeButtonRegion = false)]
  ])
})